import React, { useEffect, useState } from "react";
import AppHeader from "../../components/header";
import TopSection from "../../components/sections/TopSection/index";
/* eslint-disable */
/* eslint-enable */
// import CheapestDestinations from "../../components/sections/CheapestDestinations/CheapestDestinations";
// import BlogCardSection from "../../components/sections/HomepageBlogCard/HomepageBlogCard";
// import MobileApps from "../../components/sections/MobileApps/MobileApps";
// import TextSection from "../../components/sections/BottomTextSetion/BottomTextSetion";
import Footer from "../../components/footer";
import "./styles.scss";
import HotelItemCardModal from "../../components/Modals/HotelItemCardModal";
import HotelItemCardWebLinkModal from "../../components/Modals/HotelItemCardWebLinkModal";
import useKeyboardStatus from "../../helpers/Keyboard";
import ScrollLock from "../../components/ScrollLock";
import CookieConsent from "../../components/CookieConsent/CookieConsent";
import AppConfig from "../../helpers/config";
import { setActivityIndicator, setBranchData, setTransactionId } from "../../redux/slices/appconfigSlice";
import branch from "branch-sdk";
import { useDispatch, useSelector } from "react-redux";
import { ServiceGetTransactionId } from "../../services/AppService";
import { requestNotificationPermission } from "../../onesignal";
import { getChatBotData, setIsInitialUserChat } from "../../redux/slices/chatBotSlice";
import { isMobile, isTablet, isAndroid } from 'react-device-detect';
import { buildTransactionCampaign } from "../../helpers/transactionCampaign";
import DownloadApp from "../../components/DownloadApp";
import { getLoginConfig, setHasClosedDownloadSection } from "../../redux/slices/loginconfigSlice";
// import PublicBeta from "../../assets/images/icons/Public-Beta.svg";
import { decodeShareData, SHARE_PARAM_KEY } from "../../utils/webShareLink";

// Master switch for the "Download App" banner. Set to false to hide it entirely.
const ENABLE_DOWNLOAD_BANNER = false;

const Home = () => {
    const consent = localStorage.getItem("cookie_consent");
    const dispatch = useDispatch();
    const isKeyboardOpen = useKeyboardStatus();
    const [consentGiven, setConsentGiven] = useState(!!consent);
    const { initialUserChat  } = useSelector(getChatBotData);
    const loginConfig = useSelector(getLoginConfig);
    const [showDownloadSection, setShowDownloadSection] = useState(false);
    // Decoded flat data from a web-based package share link (/link?data={token}).
    const [sharedData, setSharedData] = useState(null);

    useEffect(() => {
        // Web-based package share links land on /link?data={token}. Decode the
        // embedded flat share data so the Web Link modal can render it. This is a
        // parallel flow to Branch — the Branch init below is untouched.
        const token = new URLSearchParams(window.location.search).get(SHARE_PARAM_KEY);
        if (window.location.pathname === '/link' && token) {
            console.log(decodeShareData(token));
            localStorage.setItem('roomFetched', 'false');
            localStorage.setItem('flightFetched', 'false');
            setSharedData(decodeShareData(token));
        }

        // Read link data from the init callback so we get the CURRENTLY clicked
        // link, not Branch's cached previous session. Always set (null when there is
        // no payload) so stale branch data from a previous link is cleared.
        branch.init(AppConfig.branchKey, (err, data) => {
            const payload = data?.data_parsed?.payload;
            dispatch(setBranchData(payload ? JSON.parse(payload) : null));
        });

        if (isMobile || isTablet) {
            if (loginConfig?.currency?.code !== 'USD' && !loginConfig?.hasClosedDownloadSection) {
                setShowDownloadSection(true);
            }
        }

        // Fire-and-forget: this must never surface as an unhandled rejection on a
        // device that cannot receive push (iOS Safari outside a Home Screen install,
        // in-app browsers, denied permission).
        requestNotificationPermission().catch((error) => {
            console.warn("OneSignal: permission request failed —", error?.message || error);
        }); // This will check if notifications are enabled.
    }, []);

    useEffect(() => {
        if (consent && !initialUserChat) {
            getTransactionIdService();
        }
    }, [consentGiven]);

    const getTransactionIdService = async () => {
        dispatch(setActivityIndicator(true));
        const cookieId = await localStorage.getItem("GA_COOKIE_ID");
        try {
            const response = await ServiceGetTransactionId({
                transaction_channel: "site",
                transaction_campaign: buildTransactionCampaign(cookieId),
                device_id: cookieId
            });
            dispatch(setTransactionId(response?.data?.transaction_id));
            dispatch(setActivityIndicator(false));
            dispatch(setIsInitialUserChat(true));
            localStorage.setItem('last_session_timestamp', Date.now().toString());
        } catch (error) {
            console.error({ error });
            dispatch(setActivityIndicator(false));
        }
    };

    return (
        <>
            {/* <img className="public-beta" src={PublicBeta} alt="" /> */}
            <div className="main-wrapper chat-page">
                <AppHeader />
                <main className="body-wrapper">
                    <ScrollLock isOpen={isKeyboardOpen && (isMobile || isTablet)}>
                        <TopSection chatShouldInitiate={initialUserChat} />
                        {/*<BlogCardSection/>*/}
                        {/* <MobileApps /> */}
                        {/*<TextSection/>*/}
                        {initialUserChat && !sharedData && <HotelItemCardModal />}
                        {initialUserChat && sharedData && (
                            <HotelItemCardWebLinkModal
                                sharedData={sharedData}
                                onClose={() => setSharedData(null)}
                            />
                        )}
                        <CookieConsent onConsentGiven={() => setConsentGiven(true)} />
                    </ScrollLock>
                </main>
                <Footer />
            </div>
            {ENABLE_DOWNLOAD_BANNER && showDownloadSection && (isMobile || isTablet) && !isAndroid &&
                <DownloadApp setShowDownloadSection={(value) => {
                    setShowDownloadSection(value);
                    if (!value) {
                        // This timeout is set to avoid re-rendering of chat.
                        setTimeout(() => {
                            dispatch(setHasClosedDownloadSection(true));
                        }, 5000);
                    }
                }}
                />}
        </>
    );
};

export default Home;
